export const tr = {
    'add-group': 'Grup ekle',
    'combinations-count': {
        one: '{count} sözcük grubu oluşturulup listeye eklenecek.',
        some: '{count} sözcük grubu oluşturulup listeye eklenecek.',
        many: '{count} sözcük grubu oluşturulup listeye eklenecek.',
        none: '{count} sözcük grubu oluşturulup listeye eklenecek.'
    }
};
